import Form from '../_form';

export default class ResetPasswordForm extends Form {

    /* eslint-disable no-useless-constructor */
    constructor (query) {
        super(query);

        const form = document.querySelector(query);
        if (!form) return;

        const text = document.querySelector('#reset-password-text');
        if (!text) throw new Error('Dashboard text element not found!');

        const success = document.querySelector('#reset-password-success');
        if (!success) throw new Error('Dashboard success element not found!');

        this.success = success;
        this.text = text;
    }

    handleSuccess () {
        this.form.classList.add('hidden');
        this.success.classList.remove('hidden');
        this.text.classList.add('hidden');
    }

    async finalizeForm () {
        if (this.submit) this.submit.classList.add('preload');

        const formData = new FormData(this.form);

        const email = formData.get('email');

        try {
            await fetch('/wp-json/user/v1/reset-password', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email })
            })
            .then((response) => response.json())
            .then((data) => {
                if (data && !data.error) {
                    this.form.classList.remove('error');
                    this.form.classList.add('sent');

                    this.NotificationManager.sendNotification('success', 'Successfully sent!', data.message);

                    if (this.submit) this.submit.classList.remove('preload');

                    this.handleSuccess();
                } else {
                    this.NotificationManager.sendNotification('error', 'An error occurred...', data.message);

                    if (this.submit) this.submit.classList.remove('preload');

                    this.form.classList.add('error');
                }
            })
            .catch(() => {
                this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

                if (this.submit) this.submit.classList.remove('preload');

                this.form.classList.add('error');
            });
        } catch (error) {
            this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

            if (this.submit) this.submit.classList.remove('preload');

            this.form.classList.add('error');
        }
    }
}
